import { useEffect, useState } from "react";
import Button from "@weave-design/button";
import { ProcessingFailure } from "../../../../processing-failure/processingFailure";
import CategorySection from "./categorySection";
import { CategoryView, mapToViewable } from "./mapToViewable";
import "../../../../../assets/typesManagerStyles.css";
import { TypesManagerRefreshEventPayload } from "../../../eventBus/typesManagerEventPayloads";
import eventBus, { IApplicationEvent } from "../../../eventBus/eventDispatcher";

const TypesManagerContent = () => {
    const [categories, setCategories] = useState<CategoryView[]>([]);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [selectedPanelId, setSelectedPanelId] = useState<string | null>(null);

    useEffect(() => {
        const onRefresh = (event: IApplicationEvent<TypesManagerRefreshEventPayload>) => {
            setCategories(event.payload.categories.map(category => mapToViewable(category)));
            setSelectedPanelId(event.payload.selectedPanelId);
        };

        const onProcessingError = (event: IApplicationEvent<string>) => setErrorMessage(event.payload);

        eventBus.addEventListener("Dextall.TypesManager.UI.Refresh", onRefresh);
        eventBus.addEventListener("Dextall.TypesManager.ShowFailureMessage", onProcessingError);

        return () => {
            eventBus.removeEventListener("Dextall.TypesManager.UI.Refresh", onRefresh);
            eventBus.removeEventListener("Dextall.TypesManager.ShowFailureMessage", onProcessingError);
        };
    }, []);

    const generateAllPanels = () => {
        eventBus.dispatchEvent({
            type: "Dextall.TypesManager.GenerateAll.Requested",
            payload: null,
        });
    };

    const closeProcessingErrorDialog = () => {
        setErrorMessage(null);
    };

    return (
        <div className="tm-container">
            {errorMessage && (
                <ProcessingFailure
                    title="Generation failed"
                    message={errorMessage}
                    closeProcessingErrorDialog={closeProcessingErrorDialog}
                    isVisible={true}
                />
            )}
            <div className="tm-scrollable-content">
                {categories.map((category, categoryIndex) => (
                    <CategorySection key={categoryIndex} category={category} selectedPanelId={selectedPanelId} />
                ))}
            </div>
            <div className="tm-generate-button-container">
                <Button
                    style={{ width: "100px" }}
                    type="primary"
                    size="standard"
                    title="Generate All"
                    width="grow"
                    onClick={generateAllPanels}
                />
            </div>
        </div>
    );
};

export default TypesManagerContent;
